import { connect } from 'react-redux';
import { TooltippedIconButton } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName, Stack } from '@optimus-web/core';
import { startEntityDeleting } from '../../../../entityManagement/actions';
import { changeCategoryOrderingBy } from '../../../actions/categories';

interface CategoriesButtonActionsProps {
    id: string;
    moveBackInOrdering: (id: string) => void;
    moveForwardInOrdering: (id: string) => void;
    onDelete: (id: string, scope: string) => void;
    scope: string;
}

const CategoriesButtonActions = ({
    id,
    moveBackInOrdering,
    moveForwardInOrdering,
    onDelete,
    scope,
}: CategoriesButtonActionsProps) => {
    const handleDeleteClick = () => onDelete(id, scope);
    const handleMoveBack = () => moveBackInOrdering(id);
    const handleMoveForward = () => moveForwardInOrdering(id);

    return (
        <Stack>
            <TooltippedIconButton
                tooltip={<LocalizedText textKey={TextKey.Delete} />}
                onClick={handleDeleteClick}
                icon={IconName.Delete}
                size="small"
                variant="ghost"
                type="button"
            />
            <TooltippedIconButton
                tooltip={<LocalizedText textKey={TextKey.MoveUp} />}
                onClick={handleMoveBack}
                icon={IconName.ArrowUp}
                size="small"
                variant="ghost"
                type="button"
            />
            <TooltippedIconButton
                tooltip={<LocalizedText textKey={TextKey.MoveDown} />}
                onClick={handleMoveForward}
                icon={IconName.ArrowDown}
                size="small"
                variant="ghost"
                type="button"
            />
        </Stack>
    );
};

export default connect(undefined, {
    moveBackInOrdering: changeCategoryOrderingBy(-1),
    moveForwardInOrdering: changeCategoryOrderingBy(1),
    onDelete: startEntityDeleting,
})(CategoriesButtonActions);
